import React, { useState, useRef, useEffect } from "react";
import { Form } from "react-bootstrap";

const EditableCell = ({ value: initialValue, row, column, onSave }: any) => {
  const [value, setValue] = useState(initialValue);
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  // Focus input automatically when editing starts
  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  const handleDoubleClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    setValue(initialValue); 
  };

  const handleKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      setIsEditing(false);
      if (value !== initialValue) {
        await onSave(row.original, column.id, value);
      }
    } else if (e.key === "Escape") {
      setIsEditing(false);
      setValue(initialValue);
    }
  };

  return isEditing ? (
    <Form.Control
      ref={inputRef}
      type="text"
      value={value ?? ""}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      size="sm"
    />
  ) : (
    <div
      style={{ cursor: "pointer", minHeight: "28px" }}
      onDoubleClick={handleDoubleClick}
    >
      {initialValue || "—"}
    </div>
  );
};

export default EditableCell;
